import { Check, Square } from 'lucide-react';
import { ComponentType, CSSProperties } from 'react';
import { cn } from '@/Domain/utils/cn';

interface SelectablePillProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
  icon?: ComponentType<{ className?: string; style?: CSSProperties }>;
  iconColor?: string;
  testId?: string;
}

export const SelectablePill = ({
  label,
  selected,
  onToggle,
  icon: Icon,
  iconColor,
  testId,
}: SelectablePillProps) => (
  <button
    type="button"
    onClick={onToggle}
    aria-pressed={selected}
    data-testid={testId}
    className={cn(
      'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm font-medium cursor-pointer',
      'transition-colors duration-150',
      selected
        ? 'bg-muted text-foreground border-foreground hover:bg-muted'
        : 'bg-card text-muted-foreground border-border hover:bg-muted',
    )}
  >
    {Icon && (
      <Icon className="size-4 flex-shrink-0" style={iconColor ? { color: iconColor } : undefined} />
    )}
    {label}
    {selected ? (
      <span className="relative inline-flex items-center justify-center size-4 flex-shrink-0">
        <Square className="absolute inset-0 size-4" />
        <Check className="relative size-3" strokeWidth={2.5} />
      </span>
    ) : (
      <Square className="size-4 flex-shrink-0 text-muted-foreground/60" />
    )}
  </button>
);
